<div class="upload-frame data-table">
  <app-header [componentName]="compName" (searchClick)="search($event)" (iconClick)="searchIconClick($event)"
    (filterClick)="loadFilterData($event)"></app-header>
  <div class="spinner-Overlay" *ngIf="displaySpinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
  <div *ngIf="caseCount == 0">
    <p class="no-upload">{{ "CaseHistory.NoData" | translate }}</p>
  </div>
  <div [ngStyle]="
      totalRec > 0 ? { visibility: 'visible' } : { visibility: 'hidden' }
    ">
    <cdk-virtual-scroll-viewport itemSize="50" class="table-container" [ngClass]="{'expandedTable': expandTable}">

      <table mat-table [dataSource]="dataSource" matSort matSortDisableClear matSortActive="dueDateTime"
        matSortDirection="asc" (matSortChange)="sortTable($event)" aria-describedby="activeCase" class="mrg-t">
        <ng-container matColumnDef="icons">
          <th mat-header-cell id="icon" *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div [ngClass]="{
              'notification-icon-red': element.overDueFlag,
              'notification-icon-green':
                (element.caseStatus === statusNew &&
                element.overDueFlag != true) || (element.caseStatus === statusUnclaimed &&
                element.overDueFlag != true)
            }"></div>
            <div class="infoIcons" *ngIf="managerFlag">
              <span>
                <img [ngClass]="{'hideAudit': check(element.caseStatus)}" id="patientDescription"
                  alt=" {{ 'ActiveCase.auditlog' | translate }}" title="{{ 'ActiveCase.auditlog' | translate }}"
                  src="assets\images\auditlog.svg" (click)="exportLog(element.caseId)" />
              </span>
              <span>
                <img id="ActiveCase.patientDescription" alt="{{ 'ActiveCase.infoIcon' | translate }}"
                  title="{{ 'ActiveCase.infoIcon' | translate }}" src="assets\images\informattion.svg"
                  (click)="viewCaseDetails(element)" />
              </span>
            </div>
          </td>
        </ng-container>
        <!-- Case ID -->
        <ng-container matColumnDef="caseId">
          <th mat-header-cell id="caseId" *matHeaderCellDef>
            {{ "ActiveCase.caseID" | translate }}
          </th>
          <td  mat-cell *matCellDef="let element">{{ element.caseId }}</td>
        </ng-container>
        <ng-container matColumnDef="anatomy">
          <th mat-header-cell id="anatomy" *matHeaderCellDef>
            {{ "ActiveCase.anatomy" | translate }}
          </th>
          <td  mat-cell *matCellDef="let element">{{ element.anatomy | titlecase }}</td>
        </ng-container>
        <ng-container matColumnDef="imagingType">
          <th mat-header-cell id="imagingType" *matHeaderCellDef>
            {{ "ActiveCase.type" | translate }}
          </th>
          <td  mat-cell *matCellDef="let element">{{ element.imagingType }}</td>
        </ng-container>
        <ng-container matColumnDef="caseStatus">
          <th mat-header-cell id="caseStatus" *matHeaderCellDef mat-sort-header
            sortActionDescription="Sort by caseStatus">
            {{ "ActiveCase.claimedBy" | translate }}
          </th>
          <td  mat-cell *matCellDef="let element" [ngClass]="{
            newStat:
              (element.caseStatus == statusUnclaimed && element.overDueFlag != true) || (element.caseStatus == statusNew && element.overDueFlag != true),
              overDueStat: element.overDueFlag
          }">
            <div class="statusAlignColumn">
              <ng-container *ngIf="element.overDueFlag && (element.caseStatus != statusOverdueUnclaimed && element.caseStatus != statusOverdueNewUnclaimed);else second">
                <span class="flag" [ngClass]="[reviewerFlag ? 'alignFlag' : '']">
                  <img src="..\assets\images\redflag.svg" id="redFlag" alt=" {{ 'ActiveCase.redflag' | translate }}"
                  title="{{ 'ActiveCase.redflag' | translate }}" />
                </span>
              </ng-container>
              <ng-template #second>
                  <ng-container *ngIf="element.claimantUserName !== loggedInUser && !check(element.caseStatus) && element.overDueFlag != true;else third">
                    <span class="flag" [ngClass]="[reviewerFlag ? 'alignFlag' : '']">
                      <img src="assets\images\grayflag.svg" id="grayflag" alt="{{ 'ActiveCase.grayflag' | translate }}"
                        title="{{ 'ActiveCase.grayflag' | translate }}" />
                    </span>
                  </ng-container>
              </ng-template>
              <ng-template #third>
                <ng-container *ngIf="(element.claimantUserName === loggedInUser && !check(element.caseStatus) && element.overDueFlag != true);else fourth">
                  <span class="flag" [ngClass]="[reviewerFlag ? 'alignFlag' : '']" >
                      <img src="assets\images\flag.svg" id="greenflag" alt="{{ 'ActiveCase.greenflag' | translate }}"
                        title="{{ 'ActiveCase.greenflag' | translate }}" />
                    </span>
                </ng-container>
              </ng-template>
              <ng-template #fourth>
                <span class="flag" >&nbsp;</span>
              </ng-template>
              <span title="{{element.caseStatus}}" class="caseStatusTextAlign">
                {{ element.caseStatus | titlecase }}
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="createDateTime">
          <th mat-header-cell id="createDateTime" *matHeaderCellDef mat-sort-header
            sortActionDescription="Sort by createDateTime" class="createdDate">
            {{ "ActiveCase.created" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div >
              {{ element.createDateTime | localtimezone }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="dueDateTime">
          <th mat-header-cell id="dueDateTime" *matHeaderCellDef mat-sort-header
            sortActionDescription="Sort by dueDateTime" class="dueDateTime">
            {{ "ActiveCase.dueDate" | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <div >
              <span>
                {{ element.dueDateTime | localtimezone }}
              </span>
              <span class="edit"
                *ngIf="managerFlag && (element.caseStatus === statusNew || element.caseStatus === statusUnclaimed || element.caseStatus === statusOverdueNewUnclaimed || element.caseStatus === statusOverdueUnclaimed)">
                <img src="assets\images\edit.svg" alt="{{ 'ActiveCase.Editflag' | translate }}"
                  title="{{ 'ActiveCase.Editflag' | translate }}" (click)="changeDueDate(element)" />
              </span>
            </div>

          </td>
        </ng-container>
        >
        <ng-container matColumnDef="timeDifference">
          <th mat-header-cell id="timeDifference" *matHeaderCellDef mat-sort-header
            sortActionDescription="Sort by timeDifference" class="timeUntilDue">
            {{ "ActiveCase.timeUntilDue" | translate }}
          </th>
          <td  mat-cell *matCellDef="let element" [ngClass]="{
            moreThanOneDay: element.dueTimeFlag,
            oneDayDueStat: element.oneDayUntilDue,
            overDueStat: element.overDueFlag
          }">
            {{ element.reviewTime }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actionsClaim">
          <th mat-header-cell id="actionsClaim" *matHeaderCellDef></th>
          <td class="actionsClaim" [ngClass]="[reviewerFlag ? 'timeFlag' : '']" mat-cell
            *matCellDef="let element; let i = dataIndex">
            <span>
              <button class="claimBtn font-SN-core"
                *ngIf="check(element.caseStatus) || (element.claimantUserName !== loggedInUser && reviewerFlag && !element.claimBtnDisable)"
                (click)="OnClaimClick(element,'claim')" [ngClass]="
                ((element.claimantUserName !== loggedInUser && !check(element.caseStatus)) || element.claimBtnDisable)
                  ? 'btn-disabled font-16 br-4 mt-2'
                  : 'btn-status-unclaimed font-16 br-4 mt-2'
              " mat-button [disabled]="
                (element.claimantUserName !== loggedInUser && !check(element.caseStatus)) || element.claimBtnDisable
              ">
                {{ "ActiveCase.Claim" | translate }}
              </button>
              <button class="claimBtn font-SN-core btn-unclaimed" *ngIf="
                element.claimantUserName === loggedInUser &&
                reviewerFlag &&
                !check(element.caseStatus)
              " (click)="OnClaimClick(element,'unclaim')" mat-button>
                {{ "ActiveCase.UnClaim" | translate }}
              </button>
              <button class="claimBtn font-SN-core btn-unclaimed" *ngIf="managerFlag && !check(element.caseStatus)"
                (click)="OnClaimClick(element,'unassign')" mat-button>
                {{ "ActiveCase.Unassign" | translate }}
              </button>
            </span>
            <span>
              <button class="case-management-button btn-SN-default font-SN-core" *ngIf="
                (element.claimantUserName !== loggedInUser && reviewerFlag ) ||
                (check(element.caseStatus) && managerFlag)
                 " mat-button
                (click)="navigateMRI('View',element.caseId, element.caseStatus,element.sourceFacilityId )">
                {{ "ActiveCase.view" | translate }}
              </button>
              <button class="case-management-button btn-SN-default font-SN-core" *ngIf="
                (element.claimantUserName === loggedInUser && element.caseStatus !== statusNew && reviewerFlag) ||
                (!check(element.caseStatus)  && managerFlag)
              " mat-button (click)="navigateMRI('Open',element.caseId, element.caseStatus,element.sourceFacilityId)">
                {{ "ActiveCase.open" | translate }}
              </button>
            </span>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let listItem; columns: displayedColumns" [ngClass]="{
          hovered: listItem.hovered,
          highlighted: (selectedRowIndex == listItem.caseId && !listItem.overDueFlag),
          highlightedRed: (selectedRowIndex == listItem.caseId && listItem.overDueFlag)
        }" (click)="highlightRow(listItem)" (mouseover)="listItem.hovered = true"
          (mouseout)="listItem.hovered = false"></tr>
      </table>
      <button *ngIf="
      !(totalPages == activeCaseData.page + 1) &&
      activeCaseDetailsRes &&
      totalRec > 0
    " class="show-more-button btn-SN-primary font-16 br-4" (click)="showMore()">
        {{ "ActiveCase.showmore" | translate }}
      </button>
    </cdk-virtual-scroll-viewport>

  </div>
</div>